import { render, staticRenderFns } from "./ListSearch.vue?vue&type=template&id=067a89cc&scoped=true"
import script from "./ListSearch.vue?vue&type=script&lang=js"
export * from "./ListSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a89cc",
  null
  
)

export default component.exports